module.exports = __webpack_public_path__ + "static/img/DK.9efef6d1.png";